import { render, staticRenderFns } from "./SliderView.vue?vue&type=template&id=f6c87d58&"
import script from "./SliderView.vue?vue&type=script&lang=js&"
export * from "./SliderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports